import { Form, FormProps, message } from "antd";
import api from "common/api";
import { IPaymentMethod } from "common/types/common";
import { FieldData } from "rc-field-form/es/interface";
import React, { FC, createContext, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Context = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const onFinish: FormProps["onFinish"] = async (values) => {
    try {
      const payload = {
        ...values,
      };
      const response = await api.paymentMethod.addPaymentMethod(payload, id);
      message.success(
        id ? "To'lov usuli o'zgartirildi" : "To'lov usuli yaratildi"
      );
      navigate(-1);
    } catch (err) {
      console.log(err);
    }
  };

  const getById = async (id: string) => {
    try {
      const response = await api.paymentMethod.getById(id);
      const fields: FieldData[] = (
        Object.keys(response.data) as (keyof IPaymentMethod)[]
      ).map((key) => ({
        name: key,
        value: response.data[key],
      }));
      form.setFields(fields);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async () => {
    if (id)
      try {
        const response = await api.paymentMethod.delete(id);
        message.success("To'lov usuli o'chirildi");
        navigate(-1);
      } catch (err) {
        console.log(err);
      }
    else navigate(-1);
  };

  useEffect(() => {
    if (id) getById(id);
  }, []);

  return {
    state: { form },
    actions: { onFinish, handleDelete },
  };
};

const PaymentMethodsAddContext = createContext<any>({ state: {}, actions: {} });

export const PaymentMethodsAddContextProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const value = Context();
  return (
    <PaymentMethodsAddContext.Provider value={value}>
      {children}
    </PaymentMethodsAddContext.Provider>
  );
};

export default function usePaymentMethodsAddContext() {
  return useContext<ReturnType<typeof Context>>(PaymentMethodsAddContext);
}
